export const environment = {
  production: false,
  minizaemApiDomain: "https://dev.connect.minizaem.bg/",
  domain: "https://fedev.minizaem.bg/",
  isPromoBannerEnabled: false,
};
